export default __webpack_public_path__ + "static/media/icon_about.dee64a9a.svg";